"use strict";
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Reside Document
 * Reside document micro-service
 *
 * OpenAPI spec version: 0.0.1
 * Contact: peter.sokolik@thinkcreatix.com
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentControllerApi = exports.DocumentControllerApiFactory = exports.DocumentControllerApiFp = exports.DocumentControllerApiFetchParamCreator = exports.QuestionReference = exports.Pcc = exports.PartialPdfReference = exports.ChecklistItem = exports.Approval = exports.AnswerOfobject = exports.AdmissionNote = exports.AdmissionFileReference = exports.Admission = exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = void 0;
const url = __importStar(require("url"));
const portableFetch = __importStar(require("portable-fetch"));
const BASE_PATH = "//localhost:8083/".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = portableFetch) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
exports.RequiredError = RequiredError;
/**
 * @export
 * @namespace Admission
 */
var Admission;
(function (Admission) {
    /**
     * @export
     * @enum {string}
     */
    let StatusEnum;
    (function (StatusEnum) {
        StatusEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        StatusEnum["CANCELLED"] = "CANCELLED";
        StatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        StatusEnum["SIGNED"] = "SIGNED";
        StatusEnum["APPROVED"] = "APPROVED";
        StatusEnum["ARCHIVED"] = "ARCHIVED";
        StatusEnum["INCOMPLETE"] = "INCOMPLETE";
    })(StatusEnum = Admission.StatusEnum || (Admission.StatusEnum = {}));
})(Admission = exports.Admission || (exports.Admission = {}));
/**
 * @export
 * @namespace AdmissionFileReference
 */
var AdmissionFileReference;
(function (AdmissionFileReference) {
    /**
     * @export
     * @enum {string}
     */
    let PccUploadStatusEnum;
    (function (PccUploadStatusEnum) {
        PccUploadStatusEnum["SUCCESS"] = "SUCCESS";
        PccUploadStatusEnum["PENDING"] = "PENDING";
        PccUploadStatusEnum["ERROR"] = "ERROR";
    })(PccUploadStatusEnum = AdmissionFileReference.PccUploadStatusEnum || (AdmissionFileReference.PccUploadStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["ADMISSION"] = "ADMISSION";
        TypeEnum["PHOTO"] = "PHOTO";
        TypeEnum["TEMPLATE"] = "TEMPLATE";
        TypeEnum["PICTURE"] = "PICTURE";
        TypeEnum["VARIABLE"] = "VARIABLE";
        TypeEnum["ANSWER"] = "ANSWER";
        TypeEnum["PROTECTED"] = "PROTECTED";
    })(TypeEnum = AdmissionFileReference.TypeEnum || (AdmissionFileReference.TypeEnum = {}));
})(AdmissionFileReference = exports.AdmissionFileReference || (exports.AdmissionFileReference = {}));
/**
 * @export
 * @namespace AdmissionNote
 */
var AdmissionNote;
(function (AdmissionNote) {
    /**
     * @export
     * @enum {string}
     */
    let StatusEnum;
    (function (StatusEnum) {
        StatusEnum["NEW"] = "NEW";
        StatusEnum["RESOLVED"] = "RESOLVED";
        StatusEnum["CANCELLED"] = "CANCELLED";
    })(StatusEnum = AdmissionNote.StatusEnum || (AdmissionNote.StatusEnum = {}));
})(AdmissionNote = exports.AdmissionNote || (exports.AdmissionNote = {}));
/**
 * @export
 * @namespace AnswerOfobject
 */
var AnswerOfobject;
(function (AnswerOfobject) {
    /**
     * @export
     * @enum {string}
     */
    let QuestionTypeEnum;
    (function (QuestionTypeEnum) {
        QuestionTypeEnum["TEXT"] = "TEXT";
        QuestionTypeEnum["DATE"] = "DATE";
        QuestionTypeEnum["DATETIME"] = "DATETIME";
        QuestionTypeEnum["CHECKBOX"] = "CHECKBOX";
        QuestionTypeEnum["RADIO"] = "RADIO";
        QuestionTypeEnum["SELECT"] = "SELECT";
        QuestionTypeEnum["STATE_SELECT"] = "STATE_SELECT";
        QuestionTypeEnum["SIGNATURE"] = "SIGNATURE";
        QuestionTypeEnum["IMAGE"] = "IMAGE";
        QuestionTypeEnum["TEXTAREA"] = "TEXTAREA";
        QuestionTypeEnum["OBJECT"] = "OBJECT";
        QuestionTypeEnum["LIST"] = "LIST";
        QuestionTypeEnum["FILE"] = "FILE";
        QuestionTypeEnum["CURRENCY"] = "CURRENCY";
        QuestionTypeEnum["TIMEZONE_SELECT"] = "TIMEZONE_SELECT";
    })(QuestionTypeEnum = AnswerOfobject.QuestionTypeEnum || (AnswerOfobject.QuestionTypeEnum = {}));
})(AnswerOfobject = exports.AnswerOfobject || (exports.AnswerOfobject = {}));
/**
 * @export
 * @namespace Approval
 */
var Approval;
(function (Approval) {
    /**
     * @export
     * @enum {string}
     */
    let ApproverTitleEnum;
    (function (ApproverTitleEnum) {
        ApproverTitleEnum["ADMISSIONS_FINANCIAL_SPECIALIST"] = "ADMISSIONS_FINANCIAL_SPECIALIST";
        ApproverTitleEnum["ADMISSIONS_DIRECTOR"] = "ADMISSIONS_DIRECTOR";
        ApproverTitleEnum["FINANCIAL_COORDINATOR"] = "FINANCIAL_COORDINATOR";
        ApproverTitleEnum["ADMINISTRATOR"] = "ADMINISTRATOR";
        ApproverTitleEnum["SOCIAL_SERVICES_DIRECTOR"] = "SOCIAL_SERVICES_DIRECTOR";
        ApproverTitleEnum["LIAISON"] = "LIAISON";
        ApproverTitleEnum["BUSINESS_OFFICE_MANAGER"] = "BUSINESS_OFFICE_MANAGER";
        ApproverTitleEnum["EXECUTIVE_DIRECTOR"] = "EXECUTIVE_DIRECTOR";
        ApproverTitleEnum["LICENSEE"] = "LICENSEE";
        ApproverTitleEnum["GENERAL_MANAGER"] = "GENERAL_MANAGER";
    })(ApproverTitleEnum = Approval.ApproverTitleEnum || (Approval.ApproverTitleEnum = {}));
})(Approval = exports.Approval || (exports.Approval = {}));
/**
 * @export
 * @namespace ChecklistItem
 */
var ChecklistItem;
(function (ChecklistItem) {
    /**
     * @export
     * @enum {string}
     */
    let MandatoryForStatusesEnum;
    (function (MandatoryForStatusesEnum) {
        MandatoryForStatusesEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        MandatoryForStatusesEnum["CANCELLED"] = "CANCELLED";
        MandatoryForStatusesEnum["IN_PROGRESS"] = "IN_PROGRESS";
        MandatoryForStatusesEnum["SIGNED"] = "SIGNED";
        MandatoryForStatusesEnum["APPROVED"] = "APPROVED";
        MandatoryForStatusesEnum["ARCHIVED"] = "ARCHIVED";
        MandatoryForStatusesEnum["INCOMPLETE"] = "INCOMPLETE";
    })(MandatoryForStatusesEnum = ChecklistItem.MandatoryForStatusesEnum || (ChecklistItem.MandatoryForStatusesEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let CheckedStatusEnum;
    (function (CheckedStatusEnum) {
        CheckedStatusEnum["OPEN"] = "OPEN";
        CheckedStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        CheckedStatusEnum["COMPLETED"] = "COMPLETED";
        CheckedStatusEnum["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    })(CheckedStatusEnum = ChecklistItem.CheckedStatusEnum || (ChecklistItem.CheckedStatusEnum = {}));
})(ChecklistItem = exports.ChecklistItem || (exports.ChecklistItem = {}));
/**
 * @export
 * @namespace PartialPdfReference
 */
var PartialPdfReference;
(function (PartialPdfReference) {
    /**
     * @export
     * @enum {string}
     */
    let PccUploadStatusEnum;
    (function (PccUploadStatusEnum) {
        PccUploadStatusEnum["SUCCESS"] = "SUCCESS";
        PccUploadStatusEnum["PENDING"] = "PENDING";
        PccUploadStatusEnum["ERROR"] = "ERROR";
    })(PccUploadStatusEnum = PartialPdfReference.PccUploadStatusEnum || (PartialPdfReference.PccUploadStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["ADMISSION"] = "ADMISSION";
        TypeEnum["PHOTO"] = "PHOTO";
        TypeEnum["TEMPLATE"] = "TEMPLATE";
        TypeEnum["PICTURE"] = "PICTURE";
        TypeEnum["VARIABLE"] = "VARIABLE";
        TypeEnum["ANSWER"] = "ANSWER";
        TypeEnum["PROTECTED"] = "PROTECTED";
    })(TypeEnum = PartialPdfReference.TypeEnum || (PartialPdfReference.TypeEnum = {}));
})(PartialPdfReference = exports.PartialPdfReference || (exports.PartialPdfReference = {}));
/**
 * @export
 * @namespace Pcc
 */
var Pcc;
(function (Pcc) {
    /**
     * @export
     * @enum {string}
     */
    let RelatedAdmissionStatusEnum;
    (function (RelatedAdmissionStatusEnum) {
        RelatedAdmissionStatusEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        RelatedAdmissionStatusEnum["CANCELLED"] = "CANCELLED";
        RelatedAdmissionStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        RelatedAdmissionStatusEnum["SIGNED"] = "SIGNED";
        RelatedAdmissionStatusEnum["APPROVED"] = "APPROVED";
        RelatedAdmissionStatusEnum["ARCHIVED"] = "ARCHIVED";
        RelatedAdmissionStatusEnum["INCOMPLETE"] = "INCOMPLETE";
    })(RelatedAdmissionStatusEnum = Pcc.RelatedAdmissionStatusEnum || (Pcc.RelatedAdmissionStatusEnum = {}));
})(Pcc = exports.Pcc || (exports.Pcc = {}));
/**
 * @export
 * @namespace QuestionReference
 */
var QuestionReference;
(function (QuestionReference) {
    /**
     * @export
     * @enum {string}
     */
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["TEXT"] = "TEXT";
        TypeEnum["DATE"] = "DATE";
        TypeEnum["DATETIME"] = "DATETIME";
        TypeEnum["CHECKBOX"] = "CHECKBOX";
        TypeEnum["RADIO"] = "RADIO";
        TypeEnum["SELECT"] = "SELECT";
        TypeEnum["STATE_SELECT"] = "STATE_SELECT";
        TypeEnum["SIGNATURE"] = "SIGNATURE";
        TypeEnum["IMAGE"] = "IMAGE";
        TypeEnum["TEXTAREA"] = "TEXTAREA";
        TypeEnum["OBJECT"] = "OBJECT";
        TypeEnum["LIST"] = "LIST";
        TypeEnum["FILE"] = "FILE";
        TypeEnum["CURRENCY"] = "CURRENCY";
        TypeEnum["TIMEZONE_SELECT"] = "TIMEZONE_SELECT";
    })(TypeEnum = QuestionReference.TypeEnum || (QuestionReference.TypeEnum = {}));
})(QuestionReference = exports.QuestionReference || (exports.QuestionReference = {}));
/**
 * DocumentControllerApi - fetch parameter creator
 * @export
 */
exports.DocumentControllerApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Generate PDF based on given admission data and save the generated PDF into a persistent storage
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSavePdfUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling generateAndSavePdfUsingPOST.');
            }
            const localVarPath = `/api/v3/documents/generate/save`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Admission" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate and upload PDF to PCC based on given admission data
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndUploadPdfToPointClickCareUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling generateAndUploadPdfToPointClickCareUsingPOST.');
            }
            const localVarPath = `/api/v3/documents/generate/pcc`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Admission" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate basic rates PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options = {}) {
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken', 'Required parameter accessToken was null or undefined when calling generateBasicRatesPdfUsingGET.');
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter admissionId was null or undefined when calling generateBasicRatesPdfUsingGET.');
            }
            const localVarPath = `/api/v3/documents/{admissionId}/generate/rates`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingGET(accessToken, admissionId, body, authorization, options = {}) {
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken', 'Required parameter accessToken was null or undefined when calling generatePdfUsingGET.');
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter admissionId was null or undefined when calling generatePdfUsingGET.');
            }
            const localVarPath = `/api/v3/documents/{admissionId}/generate`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = '*/*';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling generatePdfUsingPOST.');
            }
            const localVarPath = `/api/v3/documents/generate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Admission" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get template for facility settings
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options = {}) {
            // verify required parameter 'admissionTemplateId' is not null or undefined
            if (admissionTemplateId === null || admissionTemplateId === undefined) {
                throw new RequiredError('admissionTemplateId', 'Required parameter admissionTemplateId was null or undefined when calling getFacilitySettingsTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/facility-settings-template/{admissionTemplateId}`
                .replace(`{${"admissionTemplateId"}}`, encodeURIComponent(String(admissionTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get latest PDF template for given template name
         * @param {string} templateName templateName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPdfTemplateUsingGET(templateName, authorization, options = {}) {
            // verify required parameter 'templateName' is not null or undefined
            if (templateName === null || templateName === undefined) {
                throw new RequiredError('templateName', 'Required parameter templateName was null or undefined when calling getLatestPdfTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/template/{templateName}/pdf/latest`
                .replace(`{${"templateName"}}`, encodeURIComponent(String(templateName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get latest admission document for facility
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTemplateVersionUsingGET(facilityId, authorization, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError('facilityId', 'Required parameter facilityId was null or undefined when calling getLatestTemplateVersionUsingGET.');
            }
            const localVarPath = `/api/v3/documents/facilities/{facilityId}/version`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate partial PDF template for given group key. Group key is made by replacing all non-word chars of group id with underscore.
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} groupKey groupKey
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options = {}) {
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken', 'Required parameter accessToken was null or undefined when calling getPartialPdfUsingGET.');
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter admissionId was null or undefined when calling getPartialPdfUsingGET.');
            }
            // verify required parameter 'groupKey' is not null or undefined
            if (groupKey === null || groupKey === undefined) {
                throw new RequiredError('groupKey', 'Required parameter groupKey was null or undefined when calling getPartialPdfUsingGET.');
            }
            const localVarPath = `/api/v3/documents/{admissionId}/generate/{groupKey}`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)))
                .replace(`{${"groupKey"}}`, encodeURIComponent(String(groupKey)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = '*/*';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get template for preflight
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreflightTemplateUsingGET(admissionTemplateId, authorization, options = {}) {
            // verify required parameter 'admissionTemplateId' is not null or undefined
            if (admissionTemplateId === null || admissionTemplateId === undefined) {
                throw new RequiredError('admissionTemplateId', 'Required parameter admissionTemplateId was null or undefined when calling getPreflightTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/preflight-template/{admissionTemplateId}`
                .replace(`{${"admissionTemplateId"}}`, encodeURIComponent(String(admissionTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get template for resident experience prelude
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options = {}) {
            // verify required parameter 'admissionTemplateId' is not null or undefined
            if (admissionTemplateId === null || admissionTemplateId === undefined) {
                throw new RequiredError('admissionTemplateId', 'Required parameter admissionTemplateId was null or undefined when calling getResidentExperiencePreludeTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/resident-experience-prelude-template/{admissionTemplateId}`
                .replace(`{${"admissionTemplateId"}}`, encodeURIComponent(String(admissionTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get template for admission version
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUsingGET(admissionTemplateId, authorization, options = {}) {
            // verify required parameter 'admissionTemplateId' is not null or undefined
            if (admissionTemplateId === null || admissionTemplateId === undefined) {
                throw new RequiredError('admissionTemplateId', 'Required parameter admissionTemplateId was null or undefined when calling getTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/template/{admissionTemplateId}`
                .replace(`{${"admissionTemplateId"}}`, encodeURIComponent(String(admissionTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get admission document for facility by version id
         * @param {string} facilityId facilityId
         * @param {string} versionId versionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateVersionUsingGET(facilityId, versionId, authorization, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError('facilityId', 'Required parameter facilityId was null or undefined when calling getTemplateVersionUsingGET.');
            }
            // verify required parameter 'versionId' is not null or undefined
            if (versionId === null || versionId === undefined) {
                throw new RequiredError('versionId', 'Required parameter versionId was null or undefined when calling getTemplateVersionUsingGET.');
            }
            const localVarPath = `/api/v3/documents/facilities/{facilityId}/version/{versionId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get templates list
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplatesNamesUsingGET(authorization, options = {}) {
            const localVarPath = `/api/v3/documents/templates`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Call to this endpoint will trigger facility template synchronization
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizeUsingGET(authorization, options = {}) {
            const localVarPath = `/api/v3/documents/synchronize`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentControllerApi - functional programming interface
 * @export
 */
exports.DocumentControllerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Generate PDF based on given admission data and save the generated PDF into a persistent storage
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSavePdfUsingPOST(body, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).generateAndSavePdfUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate and upload PDF to PCC based on given admission data
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndUploadPdfToPointClickCareUsingPOST(body, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).generateAndUploadPdfToPointClickCareUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate basic rates PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingGET(accessToken, admissionId, body, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).generatePdfUsingGET(accessToken, admissionId, body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingPOST(body, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).generatePdfUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get template for facility settings
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get latest PDF template for given template name
         * @param {string} templateName templateName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPdfTemplateUsingGET(templateName, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).getLatestPdfTemplateUsingGET(templateName, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get latest admission document for facility
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTemplateVersionUsingGET(facilityId, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).getLatestTemplateVersionUsingGET(facilityId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate partial PDF template for given group key. Group key is made by replacing all non-word chars of group id with underscore.
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} groupKey groupKey
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get template for preflight
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreflightTemplateUsingGET(admissionTemplateId, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).getPreflightTemplateUsingGET(admissionTemplateId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get template for resident experience prelude
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get template for admission version
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUsingGET(admissionTemplateId, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).getTemplateUsingGET(admissionTemplateId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get admission document for facility by version id
         * @param {string} facilityId facilityId
         * @param {string} versionId versionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateVersionUsingGET(facilityId, versionId, authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).getTemplateVersionUsingGET(facilityId, versionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get templates list
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplatesNamesUsingGET(authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).getTemplatesNamesUsingGET(authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => (Object.assign(Object.assign({}, response), { data })));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Call to this endpoint will trigger facility template synchronization
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizeUsingGET(authorization, options) {
            const localVarFetchArgs = exports.DocumentControllerApiFetchParamCreator(configuration).synchronizeUsingGET(authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * DocumentControllerApi - factory interface
 * @export
 */
exports.DocumentControllerApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Generate PDF based on given admission data and save the generated PDF into a persistent storage
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSavePdfUsingPOST(body, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).generateAndSavePdfUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate and upload PDF to PCC based on given admission data
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndUploadPdfToPointClickCareUsingPOST(body, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).generateAndUploadPdfToPointClickCareUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate basic rates PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingGET(accessToken, admissionId, body, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).generatePdfUsingGET(accessToken, admissionId, body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingPOST(body, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).generatePdfUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get template for facility settings
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get latest PDF template for given template name
         * @param {string} templateName templateName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPdfTemplateUsingGET(templateName, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).getLatestPdfTemplateUsingGET(templateName, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get latest admission document for facility
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTemplateVersionUsingGET(facilityId, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).getLatestTemplateVersionUsingGET(facilityId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate partial PDF template for given group key. Group key is made by replacing all non-word chars of group id with underscore.
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} groupKey groupKey
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get template for preflight
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreflightTemplateUsingGET(admissionTemplateId, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).getPreflightTemplateUsingGET(admissionTemplateId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get template for resident experience prelude
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get template for admission version
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUsingGET(admissionTemplateId, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).getTemplateUsingGET(admissionTemplateId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get admission document for facility by version id
         * @param {string} facilityId facilityId
         * @param {string} versionId versionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateVersionUsingGET(facilityId, versionId, authorization, options) {
            return exports.DocumentControllerApiFp(configuration).getTemplateVersionUsingGET(facilityId, versionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get templates list
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplatesNamesUsingGET(authorization, options) {
            return exports.DocumentControllerApiFp(configuration).getTemplatesNamesUsingGET(authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Call to this endpoint will trigger facility template synchronization
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizeUsingGET(authorization, options) {
            return exports.DocumentControllerApiFp(configuration).synchronizeUsingGET(authorization, options)(fetch, basePath);
        },
    };
};
/**
 * DocumentControllerApi - object-oriented interface
 * @export
 * @class DocumentControllerApi
 * @extends {BaseAPI}
 */
class DocumentControllerApi extends BaseAPI {
    /**
     *
     * @summary Generate PDF based on given admission data and save the generated PDF into a persistent storage
     * @param {Admission} body admission
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    generateAndSavePdfUsingPOST(body, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).generateAndSavePdfUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate and upload PDF to PCC based on given admission data
     * @param {Admission} body admission
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    generateAndUploadPdfToPointClickCareUsingPOST(body, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).generateAndUploadPdfToPointClickCareUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate basic rates PDF based on given admission data
     * @param {string} accessToken accessToken
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate PDF based on given admission data
     * @param {string} accessToken accessToken
     * @param {string} admissionId admissionId
     * @param {string} [body] gaugeToken
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    generatePdfUsingGET(accessToken, admissionId, body, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).generatePdfUsingGET(accessToken, admissionId, body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate PDF based on given admission data
     * @param {Admission} body admission
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    generatePdfUsingPOST(body, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).generatePdfUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get template for facility settings
     * @param {string} admissionTemplateId identifier of admission&#x27;s template
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get latest PDF template for given template name
     * @param {string} templateName templateName
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getLatestPdfTemplateUsingGET(templateName, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).getLatestPdfTemplateUsingGET(templateName, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get latest admission document for facility
     * @param {string} facilityId facilityId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getLatestTemplateVersionUsingGET(facilityId, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).getLatestTemplateVersionUsingGET(facilityId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate partial PDF template for given group key. Group key is made by replacing all non-word chars of group id with underscore.
     * @param {string} accessToken accessToken
     * @param {string} admissionId admissionId
     * @param {string} groupKey groupKey
     * @param {string} [body] gaugeToken
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get template for preflight
     * @param {string} admissionTemplateId identifier of admission&#x27;s template
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getPreflightTemplateUsingGET(admissionTemplateId, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).getPreflightTemplateUsingGET(admissionTemplateId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get template for resident experience prelude
     * @param {string} admissionTemplateId identifier of admission&#x27;s template
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get template for admission version
     * @param {string} admissionTemplateId identifier of admission&#x27;s template
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getTemplateUsingGET(admissionTemplateId, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).getTemplateUsingGET(admissionTemplateId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get admission document for facility by version id
     * @param {string} facilityId facilityId
     * @param {string} versionId versionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getTemplateVersionUsingGET(facilityId, versionId, authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).getTemplateVersionUsingGET(facilityId, versionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get templates list
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getTemplatesNamesUsingGET(authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).getTemplatesNamesUsingGET(authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Call to this endpoint will trigger facility template synchronization
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    synchronizeUsingGET(authorization, options) {
        return exports.DocumentControllerApiFp(this.configuration).synchronizeUsingGET(authorization, options)(this.fetch, this.basePath);
    }
}
exports.DocumentControllerApi = DocumentControllerApi;
